import axios        from 'axios';
import authHeader   from 'services/auth-header';

class AppointmentsService  {
  monthlySchedule(parameters) {
    return axios
      .get(process.env.REACT_APP_API_ENDPOINT + 'v3/appointments', { headers: authHeader(), params: parameters })
      .then(response => {
        return response.data;
      }
    );
  }

  dailySchedule(parameters) {
    return axios
      .get(process.env.REACT_APP_API_ENDPOINT + 'v3/appointments/day_availability', { headers: authHeader(), params: parameters })
      .then(response => {
        return response.data;
      }
    );
  }

  weeklySchedule(parameters) {
    return axios
      .get(process.env.REACT_APP_API_ENDPOINT + 'v3/appointments/week_availability', { headers: authHeader(), params: parameters })
      .then(response => {
        return response.data;
      }
    );
  }

  // follow up appointment video call
  slots(parameters){
    // date
    // location
    return axios
      .get(process.env.REACT_APP_API_ENDPOINT + 'slots', { headers: authHeader(), params: parameters })
      .then(response => {
        return response.data;
      }
    );
  }
}

export default new AppointmentsService();